












import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const Foodsettlementpage = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [settlements, setSettlements] = useState([]);
    const [filteredSettlements, setFilteredSettlements] = useState([]);
    const [showStatusModal, setShowStatusModal] = useState(false);
    const [selectedSettlement, setSelectedSettlement] = useState(null);
    const [newStatus, setNewStatus] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [amount, setAmount] = useState("");
    const [walletBalance, setWalletBalance] = useState(null);
    const [checkingBalance, setCheckingBalance] = useState(false);

    // NEW: Filter states like Userdetails file
    const [searchType, setSearchType] = useState("partnerId"); // Default search type
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("");

    const { showLoader, hideLoader } = useLoader();

    // Search options for dropdown
    const searchOptions = [
        { value: "partnerId", label: "Partner ID" },
        { value: "id", label: "Settlement ID" },
        { value: "transactionId", label: "Transaction ID" },
        { value: "partnerUpiId", label: "UPI ID" },
        { value: "partnerBankAccountNumber", label: "Bank Account" }
    ];

    // Status options for dropdown
    // Status options for dropdown
    const statusOptions = [
        { value: "", label: "All Status" },
        // { value: "PAID", label: "Paid" },
        { value: "COMPLETED", label: "Completed" },
        { value: "PENDING", label: "Pending" },
        // { value: "REJECTED", label: "Rejected" }
    ];
    // NEW: Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "partnerId": return "Search Partner ID";
            case "id": return "Search Settlement ID";
            case "transactionId": return "Search Transaction ID";
            case "partnerUpiId": return "Search UPI ID";
            case "partnerBankAccountNumber": return "Search Bank Account";
            default: return "Search...";
        }
    };

    // NEW: Clear all filters
    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedDate("");
        setStatusFilter("");
    };

    // Fetch settlements from API
    useEffect(() => {
        fetchSettlements();
    }, []);

    const fetchSettlements = () => {
        const token = localStorage.getItem("authToken");
        showLoader();
        axios
            .get("https://backend.maamaas.com/delivery/api/admin/get/settlements/all", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                },
            })
            .then((res) => {
                const data = res.data.settlements || res.data || [];
                setSettlements(data);
                setFilteredSettlements(data);
            })
            .catch((err) => console.error("Error fetching settlements:", err))
            .finally(() => {
                hideLoader();
            });
    };

    // NEW: Search filtered data
    const searchFilteredData = useMemo(() => {
        if (!settlements.length) return [];

        let data = settlements;

        // Date filter
        if (selectedDate) {
            data = data.filter(item => {
                if (!item.settlementRequestDate) return false;
                const requestDate = new Date(item.settlementRequestDate).toISOString().split("T")[0];
                return requestDate === selectedDate;
            });
        }

        // Status filter
        if (statusFilter) {
            data = data.filter((item) => {
                if (!item.settlementStatus) return false;
                return item.settlementStatus === statusFilter;
            });
        }

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            data = data.filter((item) => {
                let fieldValue = item[searchType];

                if (!fieldValue) return false;

                // Convert to string for searching
                const stringValue = String(fieldValue).toLowerCase();

                // For all fields
                return stringValue.includes(query);
            });
        }

        return data;
    }, [settlements, selectedDate, statusFilter, searchQuery, searchType]);

    // Apply filters to settlements data
    useEffect(() => {
        setFilteredSettlements(searchFilteredData);
    }, [searchFilteredData]);

    // Fetch settlement details by ID
    const fetchSettlementById = (settlementId) => {
        const token = localStorage.getItem("authToken");
        showLoader();
        return axios
            .get(`https://backend.maamaas.com/delivery/api/get/settlement/id?id=${settlementId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                },
            })
            .then((res) => {
                return res.data;
            })
            .catch((err) => {
                console.error("Error fetching settlement details:", err);
                throw err;
            })
            .finally(() => {
                hideLoader();
            });
    };

    // Function to check admin wallet balance 
    const checkAdminWalletBalance = () => {
        const token = localStorage.getItem("authToken");
        setCheckingBalance(true);

        axios
            .get("https://backend.maamaas.com/delivery/api/admin/wallet/balance", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "*/*",
                },
            })
            .then((res) => {
                const balance = res.data.balance || res.data.availableBalance || res.data;
                setWalletBalance(parseFloat(balance));
                alert(`Admin Wallet Balance: ₹${parseFloat(balance).toFixed(2)}`);
            })
            .catch((err) => {
                console.error("Error fetching wallet balance:", err);
                alert("Unable to fetch wallet balance. Please contact support.");
            })
            .finally(() => {
                setCheckingBalance(false);
            });
    };

    // Open status update modal
    const handleStatusUpdateClick = async (settlement) => {
        try {
            showLoader();

            // Fetch latest settlement details by ID
            const settlementDetails = await fetchSettlementById(settlement.id);

            setSelectedSettlement(settlementDetails);
            setNewStatus(settlementDetails.settlementStatus || "PENDING");

            // 👉 Transaction ID: use backend value or keep empty
            setTransactionId(settlementDetails.transactionId || "");

            setAmount(settlementDetails.withdrawlAmount || "");
            setWalletBalance(null); // Reset wallet balance
            setShowStatusModal(true);

        } catch (error) {
            console.error("Error loading settlement details:", error);

            // Fallback to passed settlement object
            setSelectedSettlement(settlement);
            setNewStatus(settlement.settlementStatus || "PENDING");

            // 👉 Keep transaction ID empty
            setTransactionId(settlement.transactionId || "");

            setAmount(settlement.withdrawlAmount || "");
            setWalletBalance(null);
            setShowStatusModal(true);

        } finally {
            hideLoader();
        }
    };


    // Generate transaction ID function
    const generateTransactionId = () => {
        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 10000);
        return `TXN_${timestamp}_${randomNum}`;
    };

    // Update settlement status
    const handleUpdateStatus = () => {
        if (!selectedSettlement) {
            alert("Please select a settlement");
            return;
        }

        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            alert("Please enter a valid amount");
            return;
        }

        if (!transactionId || transactionId.trim() === "") {
            // Generate a transaction ID if not provided
            setTransactionId(generateTransactionId());
            alert("Transaction ID generated automatically: " + transactionId);
            return;
        }

        const token = localStorage.getItem("authToken");
        const settlementId = selectedSettlement.id;
        const updateAmount = parseFloat(amount);

        // Prepare query parameters for the PUT API - ALL parameters are required
        const params = new URLSearchParams({
            id: settlementId,
            amount: updateAmount.toString(),
            transactionId: transactionId.trim()
        });

        showLoader();
        axios
            .put(`https://backend.maamaas.com/delivery/api/admin/update/settlement/status?${params.toString()}`,
                null, // No request body needed
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                })
            .then((res) => {
                console.log("✅ API Response:", res.data);

                if (res.data.success || res.data.message || res.data.id) {
                    alert("Settlement status updated successfully!");

                    // Refresh data from server
                    fetchSettlements();

                    // Close modal
                    setShowStatusModal(false);
                    setSelectedSettlement(null);
                    setNewStatus("");
                    setTransactionId("");
                    setAmount("");
                    setWalletBalance(null);
                } else {
                    alert(`Failed to update status: ${JSON.stringify(res.data)}`);
                }
            })
            .catch((err) => {
                console.error("❌ Error updating settlement status:", err);
                console.error("Error details:", {
                    status: err.response?.status,
                    data: err.response?.data,
                    config: err.config
                });

                const errorMessage = err.response?.data?.message ||
                    err.response?.data?.error ||
                    err.message ||
                    "Failed to update status";

                // Special handling for insufficient balance
                if (errorMessage.toLowerCase().includes('insufficient balance') ||
                    errorMessage.toLowerCase().includes('insufficient funds') ||
                    err.response?.status === 500) {

                    const confirmReject = window.confirm(
                        `💰 Insufficient Balance!\n\n` +
                        `Settlement: ₹${updateAmount}\n` +
                        `Status: Cannot process payment\n\n` +
                        `Would you like to mark this settlement as REJECTED instead?`
                    );

                    if (confirmReject) {
                        // Generate rejection transaction ID
                        const rejectTransactionId = `REJECTED_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
                        const rejectParams = new URLSearchParams({
                            id: settlementId,
                            amount: updateAmount.toString(),
                            transactionId: rejectTransactionId
                        });

                        // Retry with rejection transaction ID
                        axios.put(
                            `https://backend.maamaas.com/delivery/api/admin/update/settlement/status?${rejectParams.toString()}`,
                            null,
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                },
                            }
                        )
                            .then(rejectRes => {
                                console.log("✅ Rejection Response:", rejectRes.data);
                                if (rejectRes.data.success || rejectRes.data.message) {
                                    alert("✅ Settlement marked as REJECTED due to insufficient funds!");
                                    fetchSettlements();
                                    setShowStatusModal(false);
                                    setSelectedSettlement(null);
                                    setNewStatus("");
                                    setTransactionId("");
                                    setAmount("");
                                    setWalletBalance(null);
                                }
                            })
                            .catch(rejectErr => {
                                console.error("❌ Rejection Error:", rejectErr);
                                alert(`Failed to reject settlement: ${rejectErr.response?.data?.message || rejectErr.message}`);
                            });
                    }
                } else {
                    alert(`❌ Failed to update status: ${errorMessage}`);
                }
            })
            .finally(() => {
                hideLoader();
            });
    };

    const handleExport = () => {
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : settlements;

        if (exportData.length === 0) {
            alert("No data available for export.");
            return;
        }

        const headers = ["ID", "Partner ID", "Withdrawal Amount", "Request Date", "Settlement Date", "Payment Type", "Status", "Transaction ID", "UPI ID", "Bank Account", "IFSC", "Bank Name", "Account Holder"];
        const rows = exportData.map((it) => [
            it.id,
            it.partnerId,
            it.withdrawlAmount,
            it.settlementRequestDate ? formatDate(it.settlementRequestDate) : "-",
            it.settlementDate || "-",
            it.paymentType || "UPI",
            it.settlementStatus,
            it.transactionId || "-",
            it.partnerUpiId || "-",
            it.partnerBankAccountNumber || "-",
            it.partnerIfscCode || "-",
            it.partnerBankName || "-",
            it.partnerAccountHolderName || "-"
        ]);

        const csvContent = [headers, ...rows].map(r => r.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "settlements.csv";
        link.click();
    };

    // Get status badge style
    const getStatusStyle = (status) => {
        const baseStyle = {
            padding: "4px 8px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "500",
            display: "inline-block",
            textTransform: "uppercase"
        };

        switch (status) {
            case "PAID":
                return {
                    ...baseStyle,
                    backgroundColor: "#4CAF50",
                    color: "white"
                };
            case "PENDING":
                return {
                    ...baseStyle,
                    backgroundColor: "#FF9800",
                    color: "white"
                };
            case "REJECTED":
                return {
                    ...baseStyle,
                    backgroundColor: "#F44336",
                    color: "white"
                };
            default:
                return {
                    ...baseStyle,
                    backgroundColor: "#9E9E9E",
                    color: "white"
                };
        }
    };

    // Get payment type badge style
    const getPaymentTypeStyle = (type) => {
        const baseStyle = {
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            fontWeight: "500",
            display: 'inline-block'
        };

        switch (type) {
            case "UPI":
                return {
                    ...baseStyle,
                    backgroundColor: "#2196F3",
                    color: "white"
                };
            case "BANK_TRANSFER":
                return {
                    ...baseStyle,
                    backgroundColor: "#4CAF50",
                    color: "white"
                };
            case "NEFT":
                return {
                    ...baseStyle,
                    backgroundColor: "#9C27B0",
                    color: "white"
                };
            case "RTGS":
                return {
                    ...baseStyle,
                    backgroundColor: "#FF9800",
                    color: "white"
                };
            default:
                return {
                    ...baseStyle,
                    backgroundColor: "#9E9E9E",
                    color: "white"
                };
        }
    };

    // Format date to display only date part
    const formatDate = (dateString) => {
        if (!dateString) return "-";
        try {
            const date = new Date(dateString);
            return date.toISOString().split("T")[0];
        } catch (error) {
            return dateString;
        }
    };

    // Format date with time
    const formatDateTime = (dateString) => {
        if (!dateString) return "-";
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (error) {
            return dateString;
        }
    };

    const tableHeaderStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#e66d33",
        color: "white",
        padding: "10px 8px",
        fontSize: "13px",
        whiteSpace: "nowrap",
        position: "sticky",
        top: 0,
        zIndex: 10,
    };

    const tableCellStyle = {
        border: "1px solid #ddd",
        textAlign: "center",
        padding: "10px 8px",
        fontSize: "13px",
        whiteSpace: "nowrap",
    };

    const filterSelectStyle = {
        backgroundColor: "#b15cd6",
        color: "#fff",
        border: "none",
        height: "35px",
        borderRadius: "4px",
        padding: "0 8px"
    };

    // Modal styles
    const modalOverlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px',
    };

    const modalContentStyle = {
        backgroundColor: '#fff',
        borderRadius: '8px',
        width: '100%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
    };

    const modalHeaderStyle = {
        padding: '20px',
        borderBottom: '1px solid #eee',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    };

    const modalBodyStyle = {
        padding: '20px',
    };

    return (
        <div className="container-fluid">
            <div className="row" style={{ marginTop: "-122px" }}>
                <div className="col-lg-12 food-accounts-data-scroll" style={{ height: "85vh", overflowY: "auto", scrollbarWidth: "none" }}>
                    {/* NEW: Filters Container */}
                    <div className="row mb-3 g-2 align-items-center" style={{ marginBottom: '15px' }}>
                        {/* Search Type Dropdown and Search Input */}
                        <div className="col-md-auto col-12">
                            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                {/* Search Type Dropdown */}
                                <div style={{ minWidth: '150px' }}>
                                    <select
                                        className="form-select"
                                        value={searchType}
                                        onChange={(e) => setSearchType(e.target.value)}
                                        style={{ height: "40px" }}
                                    >
                                        {searchOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Search Input */}
                                <div style={{ minWidth: '200px' }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={getPlaceholderText()}
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ height: "40px" }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Date Filter */}
                        <div className="col-md-auto col-12">
                            <input
                                type="date"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                                style={{
                                    backgroundColor: "#e66d33",
                                    color: "#fff",
                                    border: "none",
                                    height: "40px",
                                    borderRadius: "4px",
                                    padding: "0 10px",
                                    minWidth: "150px"
                                }}
                            />
                        </div>

                        {/* Status Filter */}
                        <div className="col-md-auto col-12">
                            <select
                                className="form-select"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                                style={{ maxWidth: '150px', height: "40px" }}
                            >
                                {statusOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Clear Filters Button */}
                        <div className="col-md-auto col-12">
                            <button
                                className="btn"
                                onClick={clearAllFilters}
                                style={{
                                    backgroundColor: '#6c757d',
                                    color: '#fff',
                                    height: "40px",
                                    padding: "0 15px"
                                }}
                            >
                                Clear Filters
                            </button>
                        </div>

                        {/* Export Button */}
                        <div className="col-md col-12">
                            <div className="d-flex justify-content-start justify-content-md-end">
                                <button
                                    className="btn"
                                    onClick={handleExport}
                                    style={{
                                        backgroundColor: '#e66d33',
                                        color: '#fff',
                                        height: "40px",
                                        padding: "0 20px"
                                    }}
                                >
                                    Export
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Table Container with Horizontal Scroll */}
                    <div style={{
                        width: "100%",
                        overflowX: "auto",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        maxHeight: "70vh",
                        position: "relative"
                    }}>
                        {/* Table */}
                        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1200px" }}>
                            <thead>
                                <tr>
                                    <th style={tableHeaderStyle}>Settlement ID</th>
                                    <th style={tableHeaderStyle}>Partner ID</th>
                                    <th style={tableHeaderStyle}>Amount</th>
                                    <th style={tableHeaderStyle}>Request Date</th>
                                    <th style={tableHeaderStyle}>Settlement Date</th>
                                    <th style={tableHeaderStyle}>Payment Type</th>
                                    <th style={tableHeaderStyle}>Status</th>
                                    <th style={tableHeaderStyle}>Transaction ID</th>
                                    <th style={tableHeaderStyle}>UPI ID</th>
                                    <th style={tableHeaderStyle}>Bank Details</th>
                                    <th style={tableHeaderStyle}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSettlements.length > 0 ? (
                                    filteredSettlements.map((it) => (
                                        <tr key={it.id || it.partnerId}>
                                            <td style={tableCellStyle}>
                                                <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {it.id}
                                                </div>
                                            </td>
                                            <td style={tableCellStyle}>{it.partnerId}</td>
                                            <td style={tableCellStyle}>₹{it.withdrawlAmount || 0}</td>
                                            <td style={tableCellStyle}>{formatDateTime(it.settlementRequestDate)}</td>
                                            <td style={tableCellStyle}>{it.settlementDate || "-"}</td>
                                            <td style={tableCellStyle}>
                                                <span style={getPaymentTypeStyle(it.paymentType)}>
                                                    {it.paymentType || "UPI"}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={getStatusStyle(it.settlementStatus)}>
                                                    {it.settlementStatus}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <div style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {it.transactionId || "-"}
                                                </div>
                                            </td>
                                            <td style={tableCellStyle}>{it.partnerUpiId || "-"}</td>
                                            <td style={tableCellStyle}>
                                                {it.partnerBankAccountNumber ? (
                                                    <div style={{ textAlign: 'left', fontSize: '12px' }}>
                                                        <div><strong>Acc:</strong> {it.partnerBankAccountNumber}</div>
                                                        <div><strong>IFSC:</strong> {it.partnerIfscCode || "-"}</div>
                                                        <div><strong>Name:</strong> {it.partnerAccountHolderName || "-"}</div>
                                                    </div>
                                                ) : "-"}
                                            </td>
                                            <td style={tableCellStyle}>
                                                <button
                                                    onClick={() => handleStatusUpdateClick(it)}
                                                    style={{
                                                        padding: "4px 8px",
                                                        backgroundColor: "#2196F3",
                                                        color: "white",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                        fontSize: "12px"
                                                    }}
                                                >
                                                    Update Status
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="11" style={{ ...tableCellStyle, textAlign: 'center' }}>
                                            {settlements.length === 0
                                                ? "Loading settlements or no settlements found."
                                                : (searchQuery.trim() || selectedDate || statusFilter)
                                                    ? "No settlements found with the specified filters."
                                                    : "No settlements match the current filters."}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Status Update Modal */}
                    {showStatusModal && selectedSettlement && (
                        <div style={modalOverlayStyle} onClick={(e) => e.target === e.currentTarget && setShowStatusModal(false)}>
                            <div style={modalContentStyle}>
                                <div style={modalHeaderStyle}>
                                    <h3 style={{ margin: 0, color: '#333' }}>
                                        Update Settlement Status
                                    </h3>
                                    <button
                                        onClick={() => {
                                            setShowStatusModal(false);
                                            setSelectedSettlement(null);
                                            setNewStatus("");
                                            setTransactionId("");
                                            setAmount("");
                                            setWalletBalance(null);
                                        }}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            fontSize: '20px',
                                            cursor: 'pointer',
                                            color: '#666',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        ✕
                                    </button>
                                </div>

                                <div style={modalBodyStyle}>
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Settlement ID
                                        </label>
                                        <input
                                            type="text"
                                            value={selectedSettlement.id}
                                            readOnly
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Partner ID
                                        </label>
                                        <input
                                            type="text"
                                            value={selectedSettlement.partnerId}
                                            readOnly
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Requested Amount (Original)
                                        </label>
                                        <input
                                            type="text"
                                            value={`₹${selectedSettlement.withdrawlAmount || 0}`}
                                            readOnly
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    {/* Editable Amount Field */}
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', color: '#2196F3' }}>
                                            Settlement Amount *
                                        </label>
                                        <input
                                            type="number"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            placeholder="Enter settlement amount"
                                            min="0"
                                            step="0.01"
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #2196F3',
                                                borderRadius: '4px',
                                                backgroundColor: '#f8fdff'
                                            }}
                                            required
                                        />
                                        <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                            Enter the actual amount to be settled
                                        </small>
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Current Status
                                        </label>
                                        <div style={getStatusStyle(selectedSettlement.settlementStatus)}>
                                            {selectedSettlement.settlementStatus}
                                        </div>
                                    </div>

                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Payment Type
                                        </label>
                                        <input
                                            type="text"
                                            value={selectedSettlement.paymentType || "UPI"}
                                            readOnly
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'not-allowed'
                                            }}
                                        />
                                    </div>

                                    {/* Editable Transaction ID Field */}
                                    <div style={{ marginBottom: '15px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500', color: '#2196F3' }}>
                                            Transaction ID *
                                        </label>
                                        <input
                                            type="text"
                                            value={transactionId}
                                            onChange={(e) => setTransactionId(e.target.value)}
                                            placeholder="Enter transaction/reference ID (Required)"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: `1px solid ${transactionId ? '#2196F3' : '#f44336'}`,
                                                borderRadius: '4px',
                                                backgroundColor: transactionId ? '#f8fdff' : '#fff8f8'
                                            }}
                                        />
                                        <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                            <strong>Required:</strong> Enter transaction ID or reference number
                                        </small>

                                        {/* Transaction ID generator */}
                                        <div style={{ marginTop: '10px' }}>
                                            <button
                                                type="button"
                                                onClick={() => setTransactionId(generateTransactionId())}
                                                style={{
                                                    padding: '6px 12px',
                                                    backgroundColor: '#e3f2fd',
                                                    border: '1px solid #2196F3',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Generate Transaction ID
                                            </button>
                                        </div>
                                    </div>

                                    {/* Admin Wallet Balance Check */}
                                    <div style={{ marginBottom: '20px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                            <label style={{ fontWeight: '500', color: '#2196F3' }}>
                                                Admin Wallet Status
                                            </label>
                                            <button
                                                onClick={checkAdminWalletBalance}
                                                disabled={checkingBalance}
                                                style={{
                                                    padding: '6px 12px',
                                                    backgroundColor: checkingBalance ? '#cccccc' : '#2196F3',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: checkingBalance ? 'not-allowed' : 'pointer',
                                                    fontSize: '12px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '5px'
                                                }}
                                            >
                                                {checkingBalance ? (
                                                    <>
                                                        <span style={{
                                                            display: 'inline-block',
                                                            width: '12px',
                                                            height: '12px',
                                                            border: '2px solid currentColor',
                                                            borderRightColor: 'transparent',
                                                            borderRadius: '50%',
                                                            animation: 'spinner-border .75s linear infinite'
                                                        }}></span>
                                                        Checking...
                                                    </>
                                                ) : (
                                                    'Check Balance'
                                                )}
                                            </button>
                                        </div>

                                        {walletBalance !== null && (
                                            <div style={{
                                                padding: '10px',
                                                backgroundColor: walletBalance >= parseFloat(amount) ? '#e8f5e9' : '#ffebee',
                                                borderRadius: '4px',
                                                border: `1px solid ${walletBalance >= parseFloat(amount) ? '#4caf50' : '#f44336'}`,
                                                fontSize: '14px'
                                            }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <span style={{ fontWeight: 'bold' }}>Available Balance:</span>
                                                    <span style={{
                                                        fontWeight: 'bold',
                                                        color: walletBalance >= parseFloat(amount) ? '#2e7d32' : '#c62828',
                                                        fontSize: '16px'
                                                    }}>
                                                        ₹{walletBalance.toFixed(2)}
                                                    </span>
                                                </div>

                                                <div style={{ marginTop: '8px', fontSize: '12px' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <span>Settlement Amount:</span>
                                                        <span>₹{parseFloat(amount).toFixed(2)}</span>
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        marginTop: '4px',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        <span>Remaining After Settlement:</span>
                                                        <span style={{
                                                            color: (walletBalance - parseFloat(amount)) >= 0 ? '#2e7d32' : '#c62828'
                                                        }}>
                                                            ₹{(walletBalance - parseFloat(amount)).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </div>

                                                {walletBalance < parseFloat(amount) && (
                                                    <div style={{
                                                        marginTop: '10px',
                                                        padding: '8px',
                                                        backgroundColor: '#fff3cd',
                                                        border: '1px solid #ffeaa7',
                                                        borderRadius: '4px',
                                                        fontSize: '12px',
                                                        color: '#856404'
                                                    }}>
                                                        ⚠️ <strong>Warning:</strong> Insufficient balance for this settlement.
                                                        {walletBalance > 0 ? (
                                                            <div style={{ marginTop: '4px' }}>
                                                                You can only settle up to ₹{walletBalance.toFixed(2)}.
                                                            </div>
                                                        ) : (
                                                            <div style={{ marginTop: '4px' }}>
                                                                Admin wallet has no funds. Please add funds first.
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {walletBalance === null && !checkingBalance && (
                                            <div style={{
                                                padding: '10px',
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '4px',
                                                border: '1px solid #ddd',
                                                fontSize: '12px',
                                                color: '#666',
                                                textAlign: 'center'
                                            }}>
                                                Click "Check Balance" to view available funds
                                            </div>
                                        )}
                                    </div>

                                    <div style={{ marginBottom: '20px' }}>
                                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                                            Payment Details (Read Only)
                                        </label>
                                        <div style={{
                                            padding: '10px',
                                            backgroundColor: '#f9f9f9',
                                            borderRadius: '4px',
                                            fontSize: '12px'
                                        }}>
                                            <div><strong>UPI ID:</strong> {selectedSettlement.partnerUpiId || "-"}</div>
                                            <div><strong>Bank Account:</strong> {selectedSettlement.partnerBankAccountNumber || "-"}</div>
                                            <div><strong>IFSC:</strong> {selectedSettlement.partnerIfscCode || "-"}</div>
                                            <div><strong>Bank Name:</strong> {selectedSettlement.partnerBankName || "-"}</div>
                                            <div><strong>Account Holder:</strong> {selectedSettlement.partnerAccountHolderName || "-"}</div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <button
                                            onClick={handleUpdateStatus}
                                            style={{
                                                flex: 1,
                                                padding: '10px',
                                                backgroundColor: '#4CAF50',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Update Status
                                        </button>
                                        <button
                                            onClick={() => {
                                                setShowStatusModal(false);
                                                setSelectedSettlement(null);
                                                setNewStatus("");
                                                setTransactionId("");
                                                setAmount("");
                                                setWalletBalance(null);
                                            }}
                                            style={{
                                                flex: 1,
                                                padding: '10px',
                                                backgroundColor: '#f5f5f5',
                                                color: '#333',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Foodsettlementpage;